import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import arifadoc from '../../../../assets/images/Doctorsimages/afriadoc.png' // Assuming naming convention
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const ArifaDoc = () => {
  const navigate = useNavigate(); 
   useEffect(() => {
       document.title = "Dr. Arifa J | Best General Dentist & Consultant | 9+ Years Experience in Dental Care";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Arifa J (BDS), a highly skilled general dentist with 9 years of clinical experience. Expert in root canal treatments, teeth alignment, full mouth rehabilitation, and patient-centric dental care. Book your consultation for comprehensive oral health today."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best dentist near me, general dentist, root canal treatment specialist, teeth alignment doctor, full mouth rehabilitation expert, consultant dentist, dental clinic head, top dentist for RCT, expert in dental diagnosis, comprehensive dental care, dental awareness consultant, skilled dental surgeon, best doctor for teeth correction, preventive dentistry expert, professional dental consultation"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-arifa-j-dentist-chennai");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-arifa-j-dentist-chennai");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });
    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const marginLeft = 10;
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }
      pdf.save('Dr.Arifa_J_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
      container.classList.remove('veenadoc-pdf-mode');
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Arifa J</span>
                  <span className="veenadoc-title-credentials">(BDS)</span>
                  <span className="veenadoc-title-location">Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Recognized as a highly skilled general dentist and a dedicated consultant with over <strong>9</strong> years of 
                    rich clinical experience. Known for her expertise in diagnosing complex oral health issues and delivering 
                    comprehensive treatment plans, she has established herself as a trusted name in the dental profession.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
                    className="veenadoc-btn-primary-gradient"
                    onClick={() => navigate('/bookconsultation')}
                  >
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={arifadoc} alt="Professional photo of Dr. Arifa J (BDS), a highly skilled Consultant Dentist" className="veenadoc-doctor-image" title='Dr. Arifa J – Expert General Dentist & Consultant' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Arifa J</h2>
                  <p>
                    Dr. Arifa J (BDS) earned her degree from the prestigious Priyadarshini Dental College and Hospital, 
                    affiliated with the Tamil Nadu Dr. M.G.R. Medical University, providing her with a strong foundation 
                    in modern dental sciences.
                  </p>
                  <p>
                    With a career spanning nearly a decade, Dr. Arifa has worked with some of the most reputed dental chains 
                    in the country, including <strong>Apollo White Dental </strong> and <strong>Clove Dental</strong>. Her leadership capabilities were 
                    further solidified during her tenure as a Clinic Head, where she managed clinical operations while 
                    ensuring the highest standards of patient care.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Journey & Leadership</h2>
                  <p>
                    Her diverse experience across multispecialty clinics has equipped her with the ability to handle a wide 
                    array of dental concerns with precision and empathy. Having spent 3.5 years at <strong>Apollo White Dental</strong> and 
                    4.5 years at <strong>Clove Dental</strong>, she brings a wealth of practical knowledge to her patients.
                  </p>
                  <p>
                    She believes in delivering both comprehensive dental treatments for her patients. Her primary objective 
                    has always involved exhibiting exemplary dedication and commitment towards the profession.
                  </p>
                </div>

               
                     <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BDS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">9+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">General Dentistry & RCT</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">Chennai</span>
                    </div>
                  </div>
                </div>

                {/* Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Expertise & Specializations</h2>
                  <p>
                    Dr. Arifa’s clinical expertise is extensive, covering essential and advanced procedures such as root canal 
                    treatments (RCT), correction of teeth alignments, and full mouth rehabilitation. Patients seeking a 
                    "dentist near me" for specialized care often choose Dr. Arifa for her meticulous approach to treatment planning.
                  </p>
                  <p>
                    She believes that a successful dental outcome starts with an accurate diagnosis, and she takes the time 
                    to educate her patients on their oral health, fostering a sense of awareness and preventive care.
                  </p>
                </div>

                {/* Academic Interest */}
                <div className="veenadoc-article-block">
                  <h2>Academic Interest & Professional Growth</h2>
                  <p>
                    Beyond her clinical practice, Dr. Arifa is deeply committed to academia and professional growth. She 
                    regularly attends various state and national conferences to stay updated with the latest advancements 
                    in technology and techniques.
                  </p>
                  <p>
                    She has presented posters in various conferences, showcasing her keen interest in the evolving landscape 
                    of dental medicine. This dedication ensures that her patients receive the most modern and effective 
                    treatments available.
                  </p>
                </div>

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block">
                  <h2>Patient-Centric Approach</h2>
                  <p>
                    Her treatment philosophy is centered on exemplary dedication and commitment to the profession. She views 
                    dentistry not just as a medical service, but as a way to improve a patient’s quality of life and confidence.
                  </p>
                  <p>
                    Her approach ensures that every individual feels heard, comfortable, and well-informed throughout their 
                    dental journey, whether they are looking for routine care or complex rehabilitation.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Arifa J for Dental Excellence</h2>
                  <p>
                    Choosing Dr. Arifa J means selecting a doctor who values your health, understands your concerns, and 
                    is committed to giving you a healthy, beautiful smile through expert care and dedication.
                  </p>
                  <p>
                    For anyone searching for the best general dentist or consultant in Chennai, Dr. Arifa is the professional 
                    who brings together trust, expertise, and long-term dental wellness.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To empower patients with better oral health, renewed confidence, and 
                    exemplary dental care.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Delivering comprehensive dental treatments for my patients."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Arifa J's Philosophy of Care</p>
                  </div>
                  <p>
                    Apart from being a passionate dentist, she also has a keen interest in listening to music and reading novels, 
                    which reflects her calm and approachable personality.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Chennai</h4>
                      <p>Primary practice location</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience expert dental care with Dr. Arifa's personalized approach.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default ArifaDoc;
